import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Text } from "shared/components/Text";

import css from "./styles.module.scss";

export const RankingBar = ({ shouldCountPoints, shouldCountMeters }) => {
	const { t } = useTranslation();

	const statToRender = useMemo(() => {
		if (shouldCountPoints) {
			return (
				<Text type="white" className={css.statCaption} secondaryFamily bold>
					{t("rankingSection.points")}
				</Text>
			);
		} else if (shouldCountMeters) {
			return (
				<Text type="white" className={css.statCaption} secondaryFamily bold>
					{t("rankingSection.meters")}
				</Text>
			);
		} else {
			return (
				<Text type="white" className={css.statCaption} secondaryFamily bold>
					{t("rankingSection.time")}
				</Text>
			);
		}
	}, [shouldCountPoints, shouldCountMeters]);

	return (
		<div className={css.RankingBar}>
			<Text type="white" className={css.rankingCaption} secondaryFamily bold>
				{t("rankingSection.teamName")}
			</Text>
			<div className={css.statsContainer}>{statToRender}</div>
		</div>
	);
};
